import React from "react";
import { Skeleton } from "@mui/material";

export const Shimmer = ({ count }) => {
  const list = [...Array(count).keys()];
  return list.map(() => <Skeleton className="skeleton-shimmer" />);
};
